export default "__VITE_ASSET__D8spn9_a__"